import Pagination from '@/components/common/Pagination'
import CommonTree from '@/components/common/CommonTree';
import CommonTreeView from '@/components/common/CommonTreeView';
import CommonUpload from '@/components/common/CommonUpload';
import AutoCustomer from '@/components/common/AutoCustomer';
import WorkflowButton from '@/components/set/workflow/WorkflowButton';
import WorkflowView from '@/components/set/workflow/WorkflowView';
import Distpicker from '@/components/common/distpicker2/Distpicker';

export default {
  install: function (Vue, options) {
    Vue.component("Pagination", Pagination)
    Vue.component("CommonTree", CommonTree)
    Vue.component("CommonTreeView", CommonTreeView)
    Vue.component('CommonUpload', CommonUpload);
    Vue.component('v-distpicker', Distpicker);
    Vue.component('AutoCustomer', AutoCustomer);
    Vue.component('WorkflowButton',WorkflowButton);
    Vue.component('WorkflowView',WorkflowView);

    Vue.prototype.imgError = function (event) {
      event.target.src = './static/img/default.jpg'
      event.target.error = null
    }


    Vue.numeric = function (value, decimalplaces, needzero) {
      if (parseFloat(value || 0) == 0) {
        if (needzero == 1)
          return 0
        else
          return ""
      }
      //为了保留精度，不能直接使用toFixed。  toFixed本质是四舍六入法，某些情况才会五入 ，例如 1.555.toFixed(2)=1.55
      value = Math.round(parseFloat(value || 0) * Math.pow(10, decimalplaces || 0)) / Math.pow(10, decimalplaces || 0)
      value = value.toFixed(decimalplaces || 0)   //防止精度问题后面出现一串数字
      var value2Array = value.split(".");
      var intPart = value2Array[0]; //获取整数部分
      var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
      //表示数据有小数位
      if (value2Array.length == 2) {
        return intPartFormat + '.' + value2Array[1];
      } else {
        return intPartFormat
      }
    }

    Vue.prototype.numeric = function (value, decimalplaces, needzero) {
      return Vue.numeric(value, decimalplaces, needzero)
    }
    Vue.prototype.$numeric = function (value, decimalplaces, needzero) {
      return Vue.numeric(value, decimalplaces, needzero)
    }


    Vue.filter('numeric', (value, decimalplaces, needzero) => {
      return Vue.numeric(value, decimalplaces, needzero)
    })

    Vue.prototype.$importExcel = function (file, callBack, rabs) {
      var reader = new FileReader();
      var binary = "";
      var wb;
      var reader = new FileReader();
      reader.onload = function (e) {
        var bytes = new Uint8Array(reader.result);
        var length = bytes.byteLength;
        for (var i = 0; i < length; i++) {
          binary += String.fromCharCode(bytes[i]);
        }

        var XLSX = require('xlsx');
        if (rabs == null || rabs) {
          wb = XLSX.read(btoa(binary), {
            type: 'base64'
          });
        } else {
          wb = XLSX.read(binary, {
            type: 'binary'
          });
        }
        let outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);
        callBack(outdata);
      }
      if (rabs == null || rabs) {
        reader.readAsArrayBuffer(file);
      } else {
        reader.readAsBinaryString(file);
      }
    }

    Vue.prototype.$exportExcel = function (header, column, data, title, biaoti) {
      require.ensure([], () => {
        const {export_json_to_excel} = require('./Export2Excel');
        data = data.map(v => column.map(j => v[j]))
        let date = new Date()
        let title1 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
        export_json_to_excel(header, data, title || title1, biaoti);
      })
    }

    Vue.prototype.$checkRight = function (rightName) {
      if (rightName) {
        try {
          let model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
          if (model.gwhasright == "all")
            return true;
          let right = "|" + model.gwhasright + "|" + model.myright + "|";
          let terms = rightName.split(";")
          for (let i in terms) {
            if (terms[i] && right.indexOf("|" + terms[i] + "|") > -1) {
              return true;
            }
          }
        } catch (e) {

        }
        return false;
      }
      return true;
    }

    Vue.prototype.$isManageTenant = function () {
      let model = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      if (model.tenantid == "d6d0f500-6c34-45e6-b206-b87c368e4469")
        return true;
      return false;
    }

  }
}



// WEBPACK FOOTER //
// ./src/plugin/globalcomponents.js